import utils from 'modules/utils';
import { useMediaQuery } from 'react-responsive';
import { SubmitBtn } from './CheckPwModal';
import WindowFrame2 from './WindowFrame2';

const modalHeaderStyle = {
  borderBottom: 'none',
};
const modalBodyStyle = {
  main_section: { padding: '30px 50px 50px 50px' },
  modal_main: { padding: 0 },
  fixed_button: { padding: 0 },
};

const ChangePaymentModal = (props) => {
  const { open, close, children, handleChangeTicket, savePartAreaReservation } = props;
  const isMobile = useMediaQuery({ query: '(max-width: 480px)' });

  const ChangeTicketConfirm = async () => {
    await utils.dialog.confirm('정말 변경하시겠습니까?', '', 'question').then((res) => {
      if (res) {
        handleChangeTicket();
        savePartAreaReservation();
      }
    });
  };

  return (
    <WindowFrame2
      open={open}
      close={close}
      width={'650px'}
      height={'470px'}
      scroll={0}
      modalBodyStyle={
        isMobile
          ? {
              ...modalBodyStyle,
              main_section: {
                padding: '40px 0px',
              },
            }
          : modalBodyStyle
      }
      modalHeaderStyle={modalHeaderStyle}
      slotFixedButton={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobile ? 'center' : 'flex-end',
            gap: '20px',
          }}
        >
          <SubmitBtn
            style={{
              width: isMobile ? '90%' : '100%',
              height: '40px',
            }}
            type="button"
            onClick={() => {
              ChangeTicketConfirm();
            }}
          >
            구독권 변경
          </SubmitBtn>
          <SubmitBtn
            style={{
              width: isMobile ? '90%' : '100%',
              height: '40px',
              backgroundColor: '#e5e5e5',
              color: '#10141c',
            }}
            type="button"
            onClick={close}
          >
            구독권 유지
          </SubmitBtn>
        </div>
      }
    >
      {children}
    </WindowFrame2>
  );
};

export default ChangePaymentModal;
